import axios from "axios";
import { apiUrl } from "../components/Settings/Config";

const api = axios.create({
  baseURL: apiUrl,
  /* withCredentials: true, */
});


// Request interceptor: attach access token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `${token}`;
    }
    // ✅ Detect FormData and set proper content type
    if (config.data instanceof FormData) {
      config.headers['Content-Type'] = 'multipart/form-data';
    } else {
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: refresh token on 401/403
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      (error.response.status === 401 || error.response.status === 403) &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      try {
        const refreshResponse = await axios.post(
          `${apiUrl}refresh`,
          {},
          { withCredentials: true }
        );

        const newAccessToken = refreshResponse.data.token;
        localStorage.setItem('token', newAccessToken);

        // Retry original request with new token
        originalRequest.headers.Authorization = `${newAccessToken}`;
        return api(originalRequest);
      } catch (refreshError) {
        console.error('Refresh token failed:', refreshError);
        // Optionally logout the user or redirect to login
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;